import { AgTechRenderedPopUp } from '@agtech/core/functions/AgTechAppPopUps';
import { useAgTechWebAppContext } from '../App/Contexts/AgTechWebAppContext';
import AgTechOptions from '../Menus/AgTechOptions';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '../Menus/AgTechVerticalPopUpMenu';
import React, { CSSProperties, useEffect, useRef, useState } from 'react'

export type AgTechSearchOption<TItem> = {
    field: string,
    value: (item: TItem) => string
}

export type AgTechCoreSearchControlProps<TItem> = {
    placeholder: string,
    options: AgTechSearchOption<TItem>[],
    width?: number,
    styles?: CSSProperties,
    classes?: string
}

export type AgTechSearchControlProps<TItem> = AgTechCoreSearchControlProps<TItem> & {
    onUpdateSearchState: (searchState: AgTechSearchControlState<TItem>) => void
}

export type AgTechSearchControlState<TItem> = {
    filter: string,
    selectedField: AgTechSearchOption<TItem>
}

const AgTechSearchControl = <TItem, >(props: AgTechSearchControlProps<TItem>) => {
    let appContext = useAgTechWebAppContext();
    let renderedPopUp = useRef<AgTechRenderedPopUp>();

    let gridSearchInputRef = useRef<HTMLInputElement>(null);
    let gridSearchRef = useRef<HTMLDivElement>(null);

    let [searchState, updateSearchState] = useState<AgTechSearchControlState<TItem>>({
        filter: '',
        selectedField: props.options[0]
    });

    let searchFieldOptions = props.options.map(option => option.field);

    let handleSearchFieldSelected = (selectedField: string) => {
        updateSearchState({
            ...searchState,
            selectedField: props.options.find(option => option.field === selectedField) ?? props.options[0]
        });
    }

    useEffect(() => {
        handleSearch();
    }, [searchState.selectedField.field])

    let handleGridSearchFocus = () => {
        renderedPopUp.current = appContext.popups.showPopUp({
            popup: () =>(
                <AgTechVerticalPopUpMenu>
                    <AgTechVerticalPopUpMenuSection header="Search By:">
                        <AgTechOptions
                            selectedOption={searchState.selectedField.field}
                            options={searchFieldOptions}
                            onOptionSelected={handleSearchFieldSelected}
                        />
                    </AgTechVerticalPopUpMenuSection>
                </AgTechVerticalPopUpMenu>
            ),
            callerRef: gridSearchRef
        });
    }

    const handleGridSearchBlur = () => {
        // if (renderedPopUp.current) {
        //     renderedPopUp.current.close();
        // }
    }

    let handleSearch = () => {
        let searchTerm = gridSearchInputRef.current ? gridSearchInputRef.current.value.toLowerCase() : '';
        let searchField = searchState.selectedField;

        props.onUpdateSearchState({
            filter: searchTerm,
            selectedField: searchField
        });
    }

    let handleSearchKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    return (
        <div
            className={`tall rounded bordered bg-white column-based non-scrollable flex ${props.classes ?? ''}`}
            onFocus={handleGridSearchFocus}
            onBlur={handleGridSearchBlur}
            ref={gridSearchRef}
            style={{
                ...props.styles,
                minHeight: 32
            }}
        >
            <i
                className='fas fa-search tall text-xs text-detail px-3 border-r centered !flex'
                onClick={handleSearch}
            />
            <input
                type="text"
                className="tall font-size-small non-bordered no-outline px-2 pb-half container"
                placeholder={props.placeholder}
                onKeyDown={handleSearchKeyDown}
                ref={gridSearchInputRef}
            />
        </div>
    )
}

export default AgTechSearchControl